import React, { useEffect, useRef } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
type ConfirmationCardProps = {
  title: string;
  body: string;
  children?: React.ReactNode;
};
export function ConfirmationCard({
  title,
  body,
  children
}: ConfirmationCardProps) {
  const reduceMotion = useReducedMotion();
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    headingRef.current?.focus();
  }, []);
  return <motion.section initial={reduceMotion ? {
    opacity: 0
  } : {
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} aria-labelledby="confirmation-title" className="mx-auto w-full max-w-[560px] rounded-[14px] border border-canvas-line bg-white px-6 py-10 text-center shadow-[0_24px_48px_-32px_rgba(11,11,11,0.28)] sm:px-10 sm:py-12" data-id="element-1676" data-mp="6cizoabqt48j">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#E9F6EC]" data-id="element-1677" data-mp="1rqf2fh7juf9r">
        <CheckIcon className="h-7 w-7 text-[#1B7A3D]" strokeWidth={2.5} aria-hidden="true" data-id="element-1678" data-mp="1yczrb4guqw2k" />
      </span>
      <h1 id="confirmation-title" ref={headingRef} tabIndex={-1} className="display mt-6 text-[28px] font-semibold text-ink outline-none sm:text-[34px]" data-id="element-1679" data-mp="23ai2z2m97pe9">
        {title}
      </h1>
      <p className="mx-auto mt-3 max-w-[400px] text-[16px] leading-[1.55] text-ink-muted" data-id="element-1680" data-mp="2cao9u5ng5r4g">{body}</p>
      {children}
    </motion.section>;
}